<template>
  <div>
    <div :class="['sidebar-container d-none d-md-block',{ 'active' : Sidebar }]">1
    <!-- <div class="sidebar-container"> -->
    <div class="brand-container">
      <button class="btn-sidebar-toggler" v-on:click="toggleSidebar()">
      <!-- <button class="btn-sidebar-toggler"> -->
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div>
        <img src="@/assets/img/logos/logo-light.png" height="auto" width="100" class="ml-0 ml-md-2" />
      </div>

      <div class="app-search d-block d-md-none"></div>
      <!-- <h1 class="text-white text-center mb-0">LOGO</h1> -->
    </div>

    <div class="links-container">
      <ul class="sidebar-nav">
        <li
          v-for="(Nav, index) in SideNav"
          v-if="Nav.hasOwnProperty('permissions') && checkNavPermissions(Nav.permissions)"
          :key="index"
          v-on:click="onsidebar"
        >
          <div v-if="Nav.children && Nav.children.length > 0">
            <div class="parent-nav" v-b-toggle="'parentNav-'+index">
              <div :class="Nav.icon + ' nav-icon' "></div>

              <div class="nav-title">{{ $tc(Nav.name, 2) }}</div>
            </div>

            <b-collapse accordion="my-accordion" :id="'parentNav-'+index" v-if="Nav.children">
              <ul class="child-nav-list">
                <li
                  v-for="(ChildNav,_index) in Nav.children"
                  v-if="ChildNav.hasOwnProperty('permissions') && checkNavPermissions(ChildNav.permissions,ChildNav.cine_direct_sale)"
                  :key="_index"
                >
                  <!-- router-link-exact-active router-link-active -->
                  <router-link
                    :to="ChildNav.url"
                    @click.native="setCurrentSideNavRoute(ChildNav.url)"
                    :title="ChildNav.name"
                    :class="[' ', getCurrentSideNavRoute && getCurrentSideNavRoute === ChildNav.url ? 'router-link-exact-active router-link-active':'']"
                  >
                    <img
                      src="@/assets/img/icons/arrow-right.svg"
                      height="auto"
                      width="10"
                      class="mr-2"
                    />
                    {{ $tc(ChildNav.name, 2) }}
                  </router-link>
                </li>
              </ul>
            </b-collapse>
          </div>

          <router-link v-else :to="Nav.url" class="parent-nav">
            <span :class="Nav.icon + ' nav-icon'"></span>
            <div class="nav-title">{{ Nav.name }}</div>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- 
    <div class="powered-container">
      <div>
        Powered by
        <br />Binary Numbers
      </div>
    </div>-->
  </div>

  <!-- <div :class="['sidebar-container ',{ 'active' : Sidebar }]"> -->
    <div class="sidebar-container d-block d-md-none">
    <div class="brand-container">
      <!-- <button class="btn-sidebar-toggler" v-on:click="toggleSidebar()"> -->
      <div class="ml-3">
        <button class="btn-sidebar-toggler" @click="aside = !aside">
        <span></span>
        <span></span>
        <span></span>
      </button>
      </div>

      <div>
        <img src="@/assets/img/logos/logo-light.png" height="auto" width="100" class="ml-0 ml-md-2" />
      </div>
      <!-- <h1 class="text-white text-center mb-0">LOGO</h1> -->
    </div>

    <div class="links-container d-none">
      <ul class="sidebar-nav">
        <li
          v-for="(Nav, index) in SideNav"
          v-if="Nav.hasOwnProperty('permissions') && checkNavPermissions(Nav.permissions)"
          :key="index"
          v-on:click="onsidebar"
        >
          <div v-if="Nav.children && Nav.children.length > 0">
            <div class="parent-nav" v-b-toggle="'parentNav-'+index">
              <div :class="Nav.icon + ' nav-icon' "></div>

              <div class="nav-title">{{ $tc(Nav.name, 2) }}</div>
            </div>

            <b-collapse accordion="my-accordion" :id="'parentNav-'+index" v-if="Nav.children">
              <ul class="child-nav-list">
                <li
                  v-for="(ChildNav,_index) in Nav.children"
                  v-if="ChildNav.hasOwnProperty('permissions') && checkNavPermissions(ChildNav.permissions,ChildNav.cine_direct_sale)"
                  :key="_index"
                >
                  <!-- router-link-exact-active router-link-active -->
                  <router-link
                    :to="ChildNav.url"
                    @click.native="setCurrentSideNavRoute(ChildNav.url)"
                    :title="ChildNav.name"
                    :class="[' ', getCurrentSideNavRoute && getCurrentSideNavRoute === ChildNav.url ? 'router-link-exact-active router-link-active':'']"
                  >
                    <img
                      src="@/assets/img/icons/arrow-right.svg"
                      height="auto"
                      width="10"
                      class="mr-2"
                    />
                    {{ $tc(ChildNav.name, 2) }}
                  </router-link>
                </li>
              </ul>
            </b-collapse>
          </div>

          <router-link v-else :to="Nav.url" class="parent-nav">
            <span :class="Nav.icon + ' nav-icon'"></span>
            <div class="nav-title">{{ Nav.name }}</div>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- 
    <div class="powered-container">
      <div>
        Powered by
        <br />Binary Numbers
      </div>
    </div>-->
    <div :class="aside ? 'backdrop': ''"></div>

    <aside class="aside" :class="aside ? 'active' : ''">
      <div class="d-flex justify-content-between">
        <div class="profile-details">
          <img src="@/assets/img/icons/user-male-white.svg" height="65" width="65" />
          <div class="text-white mt-2">brij.tech@binarynumbes.io</div>
          <div class="my-2">
            <a href="">Sign in</a>
          </div>
          <div>
            <a href="">Log out</a>
          </div>
        </div>
      <div class="text-right">
        <img
        src="@/assets/img/icons/back-arrow.svg"
        height="20px"
        width="20px"
        alt="Back"
        @click="aside = !aside"
      />
      </div>
      </div>
      <div class="links-container mt-3">
      <ul class="sidebar-nav">
        <li
          v-for="(Nav, index) in SideNav"
          v-if="Nav.hasOwnProperty('permissions') && checkNavPermissions(Nav.permissions)"
          :key="index"
          v-on:click="onsidebar"
        >
          <div v-if="Nav.children && Nav.children.length > 0">
            <div class="parent-nav" v-b-toggle="'parentNav-'+index">
              <div :class="Nav.icon + ' nav-icon' "></div>

              <div class="nav-title">{{ $tc(Nav.name, 2) }}</div>
            </div>

            <b-collapse accordion="my-accordion" :id="'parentNav-'+index" v-if="Nav.children">
              <ul class="child-nav-list">
                <li
                  v-for="(ChildNav,_index) in Nav.children"
                  v-if="ChildNav.hasOwnProperty('permissions') && checkNavPermissions(ChildNav.permissions,ChildNav.cine_direct_sale)"
                  :key="_index"
                >
                  <!-- router-link-exact-active router-link-active -->
                  <router-link
                    :to="ChildNav.url"
                    @click.native="setCurrentSideNavRoute(ChildNav.url)"
                    :title="ChildNav.name"
                    :class="[' ', getCurrentSideNavRoute && getCurrentSideNavRoute === ChildNav.url ? 'router-link-exact-active router-link-active':'']"
                  >
                    <img
                      src="@/assets/img/icons/arrow-right.svg"
                      height="auto"
                      width="10"
                      class="mr-2"
                    />
                    {{ $tc(ChildNav.name, 2) }}
                  </router-link>
                </li>
              </ul>
            </b-collapse>
          </div>

          <router-link v-else :to="Nav.url" class="parent-nav">
            <span :class="Nav.icon + ' nav-icon'"></span>
            <div class="nav-title">{{ Nav.name }}</div>
          </router-link>
        </li>
      </ul>
    </div>
    </aside>
  </div>

  
  </div>
</template>



<script>
/* eslint-disable */
import Nav from "@/NavMobile";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      SideNav: Nav.items,
      Sidebar: true,
      aside: false,
      openCollapseId: null,
      fnbactive: false
    };
  },
  computed: {
    ...mapGetters(["getCurrentSideNavRoute"])
  },
  beforeMount() {
    let fnbvalue = this.secureStore.get("ENABLE_FNB");
    let roleid = this.secureStore.get("USINFO").role_id;
    // console.log("fnbvalue :", fnbvalue);
    if (roleid == 1 && fnbvalue == "N") {
      this.fnbactive = true;
    }
  },
  mounted() {
    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      if (isJustShown) {
        this.openCollapseId = collapseId;
      }
    });
  },
  methods: {
    ...mapActions(["setCurrentSideNavRoute"]),
    toggleSidebar: function() {
      this.Sidebar = !this.Sidebar;
      if (this.openCollapseId && !this.Sidebar) {
        this.$root.$emit("bv::toggle::collapse", this.openCollapseId);
        this.openCollapseId = null;
      }
    },
    onsidebar() {
      if (this.Sidebar == false) {
        this.toggleSidebar();
      }
    },
    //     goToroute: function (){
    // this.setCurrentSideNavRoute()
    //     },
    checkNavPermissions: function(permissions, direct_sale_flag) {
      // console.log("permissions :", permissions);
      if (!this.secureStore.get("USINFO")) return false;
      else {
        if (direct_sale_flag) {
          const { cine_direct_sale } = this.secureStore.get("USINFO");
          if (cine_direct_sale == "Y") {
            return false;
          }
        }
        // console.log('this.secureStore.get("USINFO") :', this.secureStore.get("USINFO"));
        const { role_name } = this.secureStore.get("USINFO");
        return permissions && permissions.length > 0
          ? permissions.filter(role => role.trim() === role_name.trim())
              .length > 0
          : true;

        // console.log("role.trim() :", role.trim());
      }
      // return true;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Containers/sidebarMobile.vue